import React from "react";
import { FaNodeJs, FaDatabase, FaDocker, FaGitAlt, FaJava, FaLinux, FaCloud, FaAndroid, FaUserFriends, FaCommentAlt, FaPeopleArrows, FaUserTie, FaLightbulb, FaSearch, FaPaintBrush, FaTools, FaBalanceScale } from "react-icons/fa";
import { SiFlutter, SiPostgresql, SiMysql, SiOracle } from "react-icons/si";
import { BiNetworkChart } from "react-icons/bi";


import { useLanguage } from "../LanguageContext";
import translations from "../translations";



const Skills = () => {

const { language } = useLanguage();

const technicalSkills = [
  { name: "Flutter", level: 9, icon: <SiFlutter className="text-blue-500" /> },
  { name: "SQL Server", level: 8, icon: <FaDatabase className="text-purple-500" /> },
  { name: "Oracle", level: 8, icon: <SiOracle className="text-red-600" /> },
  { name: "PostgreSQL", level: 8, icon: <SiPostgresql className="text-blue-600" /> },
  { name: "MySQL", level: 6, icon: <SiMysql className="text-blue-400" /> },
  { name: "Linux", level: 6, icon: <FaLinux className="text-black" /> },
  { name: "Java", level: 7, icon: <FaJava className="text-orange-600" /> },
  { name: "Android", level: 7, icon: <FaAndroid className="text-green-500" /> },
  { name: "Python", level: 5, image: "https://upload.wikimedia.org/wikipedia/commons/c/c3/Python-logo-notext.svg"},
  { name: "JavaScript", level: 5, image: "https://upload.wikimedia.org/wikipedia/commons/7/73/Javascript-736400_960_720.png"},
  { name: "Node.js", level: 5, icon: <FaNodeJs className="text-green-600" /> },
  { name: "CorelDRAW", level: 6, image: `${process.env.PUBLIC_URL}/images/coreldraw.png`},
  { name: "Git", level: 4, icon: <FaGitAlt className="text-orange-500" /> },
  { name: "Docker", level: 4, icon: <FaDocker className="text-blue-500" /> },
  { name: "APIs RESTful", level: 4, icon: <BiNetworkChart className="text-pink-500" /> },
  //{ name: "Testes Automatizados", level: 4, icon: <SiTestinglibrary className="text-red-500" /> },
  { name: "Cloud Computing (DigitalOcean/AWS/Oracle)", level: 4, icon: <FaCloud className="text-gray-600" /> },
];


const interpersonalSkills = [
  { name: translations[language].teamWork, level: 9, icon: <FaPeopleArrows className="text-green-500" /> },
  { name: translations[language].communication, level: 8, icon: <FaCommentAlt className="text-blue-500" /> },
  { name: translations[language].leadership, level: 6, icon: <FaUserTie className="text-orange-500" /> }, 
  { name: translations[language].creativeThinking, level: 7, icon: <FaLightbulb className="text-yellow-400" /> }, 
  { name: translations[language].researchSkills, level: 8, icon: <FaSearch className="text-gray-600" /> }, 
  { name: translations[language].creativity, level: 7, icon: <FaPaintBrush className="text-purple-500" /> }, 
  { name: translations[language].adaptability, level: 8, icon: <FaUserFriends className="text-teal-500" /> },
  { name: translations[language].problemSolving, level: 8, icon: <FaTools className="text-red-500" /> }, 
  { name: translations[language].decisionMaking, level: 7, icon: <FaBalanceScale className="text-blue-700" /> }, 
];

const languages = [
  { name: translations[language].Brasil, level: 10, image: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/Flag_of_Brazil.svg/1920px-Flag_of_Brazil.svg.png" },
  { name: translations[language].EUA, level: 6, image: "https://upload.wikimedia.org/wikipedia/commons/a/a4/Flag_of_the_United_States.svg" },
  { name: translations[language].Espanha, level: 1, image: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Flag_of_Spain.svg/1920px-Flag_of_Spain.svg.png" }
];
  

  return (
    <section id="skills" className="h-auto px-10 py-10 flex flex-col items-center">
      <h2 className="text-4xl font-extrabold text-gray-800 mb-6 relative inline-block">
        {translations[language].skills}
        <span className="block w-1/2 h-1 bg-blue-500 mx-auto mt-2"></span>
      </h2>

      {/* Habilidades Técnicas */}
      <div className="w-full">
        <h3 className="text-3xl font-bold text-gray-800 mb-6">{translations[language].technicalSkills}</h3>
        <div className={`grid "grid-cols-1 sm:grid-cols-2 md:grid-cols-3"} gap-8`}>
          {technicalSkills.map((skill, index) => (
            skill.icon == null 
            ? <SkillCardHT key={index} name={skill.name} level={skill.level} image={skill.image} largura={skill.largura} altura={skill.altura} />  
            : <SkillCardHT key={index} name={skill.name} level={skill.level} icon={skill.icon} />
          ))}
        </div>
      </div>

      {/* Habilidades Interpessoais */}
      <div className="w-full mb-12">
        <h3 className="text-3xl font-bold text-gray-800 py-10 mb-6">{translations[language].interpersonalSkills}</h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
          {interpersonalSkills.map((skill, index) => (
            <SkillCardHT key={index} name={skill.name} level={skill.level} icon={skill.icon} />
          ))}
        </div>
      </div>

      {/* Idiomas */}
      <div className="w-full ">
        <h3 className="text-3xl font-bold text-gray-800 mb-6">{translations[language].languages}</h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
          {languages.map((skill, index) => (
            <SkillCardLanguages key={index} name={skill.name} level={skill.level} image={skill.image} />
          ))}
        </div>
      </div>
    </section>
  );
};

//const SkillCard = ({ name, level, icon, image }) => {
//  return (
//    <div className="bg-gradient-to-r from-blue-50 to-blue-50 shadow-lg rounded-lg p-8 flex flex-col items-center text-center transition-transform transform hover:scale-105">
//      <div className="text-5xl">{icon}</div>
//      {image && <img src={image} alt={name} className="w-32 h-20 object-cover rounded-lg" />}
//      <h3 className="mt-4 text-xl font-semibold text-gray-800">{name}</h3>
//      <div className="flex mt-2">
//        {[...Array(10)].map((_, i) => (
//          <div
//            key={i}
//            className={`w-3 h-3 mx-1 rounded-full ${i < level ? "bg-blue-500" : "bg-gray-300"}`}
//          ></div>
//        ))}
//      </div>
//    </div>
//  );
//};


const SkillCardLanguages = ({ name, level, icon, image, largura, altura }) => {
  return  (
    // Versão mobile (com barra de progresso)
    <div className="bg-blue-50 shadow-md rounded-lg p-4 flex items-center gap-2">
      <div className="text-4xl">{icon}</div>
      {image && <img src={image} alt={name} className={largura == null ? "w-16 h-12 object-cover rounded-lg" : `w-${largura} h-${altura} object-cover rounded-lg` } />}
      <div className="flex-1">
        <h3 className="text-lg font-semibold">{name}</h3>
        <div className="w-full bg-gray-200 rounded-full h-2 mt-2">
          <div className="h-2 rounded-full bg-blue-500" style={{ width: `${level * 10}%` }}></div>
        </div>
      </div>
    </div>
  ) 
};


const SkillCardHT = ({ name, level, icon, image, largura, altura }) => {
  return (
    <div className="bg-blue-50 shadow-md rounded-lg p-4 flex items-center gap-2">
      <div className="text-4xl">{icon}</div>
      {image && (
        <img
          src={image}
          alt={name}
          className="object-cover rounded-lg"
          style={{
            width: largura ? `${largura}px` : "36px", // Ajustado para ficar proporcional aos ícones
            height: altura ? `${altura}px` : "36px",
          }}
        />
      )}
      <div className="flex-1">
        <h3 className="text-lg font-semibold">{name}</h3>
        <div className="w-full bg-gray-200 rounded-full h-2 mt-2">
          <div
            className="h-2 rounded-full bg-blue-500"
            style={{ width: `${level * 10}%` }}
          ></div>
        </div>
      </div>
    </div>
  );
};


export default Skills;
